/**
 * Detecta intentos básicos de Inyección SQL en una cadena de texto.
 * Utiliza Regex para buscar patrones peligrosos comunes.
 * * @param {string} value - El texto a validar.
 * @returns {Promise<boolean>} - True si se detecta una amenaza, False si es seguro.
 */
const ValidateSqlInjection = async (value) => {
    try {
        if (!value) return false;

        const upperValue = value.toUpperCase();

        // 1. Lista de palabras clave reservadas de SQL que no deberían estar en un mensaje normal
        // Se buscan palabras completas para evitar falsos positivos (ej: "INSERTAR" contiene "INSERT")
        const sqlKeywords = [
            'DROP TABLE', 'DELETE FROM', 'INSERT INTO', 'UPDATE ', 'TRUNCATE TABLE', 
            'ALTER TABLE', 'EXEC(', 'EXECUTE(', 'UNION ALL', 'UNION SELECT'
        ];

        // 2. Caracteres peligrosos comunes en ataques (comentarios, terminadores)
        // El punto y coma (;) es peligroso si se usa para encadenar comandos.
        // Los guiones dobles (--) se usan para comentar el resto de la query.
        const dangerousCharacters = [';', '--', '/*'];

        // Verificación 1: Palabras clave compuestas
        const hasKeyword = sqlKeywords.some(keyword => upperValue.includes(keyword));

        // Verificación 2: Caracteres de control
        const hasDangerousChars = dangerousCharacters.some(char => value.includes(char));

        // Verificación 3: Patrón común de ataque booleano (ej: "OR 1=1")
        const hasBooleanAttack = /\bOR\s+\d+=\d+/i.test(value);

        return hasKeyword || hasDangerousChars || hasBooleanAttack;

    } catch (error) {
        console.error("Error en ValidateSqlInjection:", error);
        // En caso de error en la validación, por seguridad asumimos que es peligroso (Fail Safe)
        return true; 
    }
};

export { ValidateSqlInjection };









// /**
//  * Función para detectar inyección SQL (ejemplo básico)
//  * @param {string} value 
//  * @returns 
//  */
// const ValidateSqlInjection = async (value) => {
//     try {    
//         const sqlInjectionKeywords = ['SELECT', 'INSERT', 'UPDATE', 'DELETE'] //';', '--', 'DROP'
        
//         return sqlInjectionKeywords.some(keyword => value.toUpperCase().includes(keyword))
//     } catch (error) {
//         await LogErrors('ValidateSqlInjection - BL Security', error)
//     }
// }

// export { ValidateSqlInjection };